import type { EmailCodesPort } from './ports.ts';
import { postToWorker, type WorkerClient } from './worker.ts';

// 6-digit email codes from the Worker (password reset while signed out,
// email confirmation while signed in). `available` is false until Guildite
// has an email provider; the screens then use Firebase's email links.
export function createEmailCodes({ worker, baseUrl, fetchImpl = fetch }: { worker: WorkerClient; baseUrl: string; fetchImpl?: typeof fetch }): EmailCodesPort {
  const open = <T>(body: Record<string, unknown>) => postToWorker<T>(fetchImpl, `${baseUrl}/api/v1/email-codes`, body);
  let available: Promise<boolean> | null = null;
  return {
    available() {
      available ??= open<{ available: boolean }>({ action: 'available' }).then(result => result.available === true, () => false);
      return available;
    },
    requestReset: async email => { await open({ action: 'request_reset', email }); },
    confirmReset: async (email, code, password) => { await open({ action: 'confirm_reset', email, code, password }); },
    sendVerifyCode: async () => { await worker.call('send_email_verification_code'); },
    confirmVerifyCode: async code => { await worker.call('confirm_email_verification_code', { code }); },
  };
}
